var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "page"
  }, [_vm.getModuleConfig('failed_page.form_title') ? _c('div', {
    staticClass: "page__title"
  }, [_vm._v(" " + _vm._s(_vm.getModuleConfig("failed_page.form_title")) + " ")]) : _vm._e(), _vm.getModuleConfig('failed_page.form_desc') ? _c('div', {
    staticClass: "page__desc"
  }, [_vm._v(" " + _vm._s(_vm.getModuleConfig("failed_page.form_desc")) + " ")]) : _vm._e(), _vm.getModuleConfig('failed_page.content') ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.getModuleConfig('failed_page.content'))
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "page__button s-space-y-4"
  }, [_c('MemberButton', {
    attrs: {
      "button-text": _vm.getModuleConfig('failed_page.button_text'),
      "button-url": _vm.getModuleConfig('failed_page.button_url'),
      "type": _vm.getModuleConfig('failed_page.button_action')
    }
  })], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }